import { vars } from '@etg/wings';
import { css } from '@eti/styles';
import { STEP_INDICATOR_HEIGHT } from '../../constants/modal';
export const blackText = css`
  color: ${vars.colors.text.primary};
`;
export const asideStyles = {
  base: css`
    flex: 1;
    height: fit-content;
    padding-top: 16px;
    position: sticky;
  `,
  top: {
    noOffset: css`
      top: 0;
    `,
    withOffset: css`
      top: calc(var(--header-offset, 0) + ${STEP_INDICATOR_HEIGHT}px + 56px);
    `
  }
};
export const nonInteractiveTextStyles = css`
  pointer-events: none;
`;
export const removeButtonStyles = {
  hidden: css`
    opacity: 0;
    pointer-events: none;
    position: absolute;
  `,
  visible: css`
    opacity: 1;
    pointer-events: auto;
  `
};
export const travelerCardStateStyles = {
  active: css`
    && {
      background: ${vars.colors.inputs.hover};
      border-color: ${vars.colors.inputs.main};
    }

    &&:hover,
    &&:active {
      background: ${vars.colors.inputs.selected};
      border-color: ${vars.colors.inputs.main};
    }
  `,
  inactive: css`
    &&,
    &&:hover,
    &&:active {
      border-color: ${vars.colors.divider};
    }
  `
};
export const seatIconStyles = css`
  path {
    stroke: ${vars.colors.text.primary};
  }
`;
//# sourceMappingURL=styles.js.map